import { CarbonRating, DietaryAttribute } from '../recipeV2/recipeV2Types';
import { ProductNutritionalInfo } from '../../../../components/shared/nutrition/types';

/** Types for the Range Planning "Items" demo screen. This is a distinct concept from both
 * the legacy Items/ProductManagementPage (Instance x Market items, real OM backend) and
 * Procurement/Products (real product catalogue backend) - it is a Demo-only, richer item
 * record used to showcase capabilities (supplier/UOM/pricing/allergens/nutrition/carbon/
 * catalogue availability/recipe usage/inventory) that don't exist end-to-end yet. Where a
 * concept is already modelled for Recipes or Products (dietary attributes, carbon rating,
 * nutrition), the same shared types/components are reused rather than re-invented. */

export enum ItemLifecycleStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  PendingReview = 'PendingReview',
}

export interface ItemSupplierDetail {
  supplierName: string;
  supplierCode: string;
  leadTimeDays: number;
  minimumOrderQuantity: number;
  alternateSuppliers: string[];
}

export interface ItemUomConversion {
  fromUom: string;
  toUom: string;
  factor: number;
}

export interface ItemPricing {
  currency: string;
  contractPrice: number;
  spotPrice?: number;
  previousPrice?: number;
  priceEffectiveDate: string;
}

export interface ItemCatalogueAvailability {
  catalogueName: string;
  available: boolean;
}

export interface ItemRecipeUsageRef {
  recipeId: number;
  recipeName: string;
}

export interface ItemInventoryMapping {
  warehouseCode: string;
  binLocation: string;
  onHandQty: number;
  reorderPoint: number;
}

export interface RangePlanningItem {
  id: number;
  itemNumber: string;
  name: string;
  category: string;
  baseUom: string;
  status: ItemLifecycleStatus;
  supplier: ItemSupplierDetail;
  uomConversions: ItemUomConversion[];
  pricing: ItemPricing;
  dietaryAttributes: DietaryAttribute[];
  carbonRating: CarbonRating;
  nutrition: ProductNutritionalInfo;
  catalogueAvailability: ItemCatalogueAvailability[];
  recipeUsage: ItemRecipeUsageRef[];
  inventoryMapping: ItemInventoryMapping[];
}

export interface RangePlanningItemListResponse {
  data: RangePlanningItem[];
  totalCount: number;
}

export interface CreateRangePlanningItemRequest {
  name: string;
  category: string;
  baseUom: string;
  supplierName: string;
}
